(function () {
  const HERO_SELECTOR = '[data-bridge-hero]';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#bridge-specs"]');
    if (!link) return;

    const target = document.getElementById('bridge-specs');
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start',
    });
  });

  function parseVariants(jsonEl) {
    try {
      const parsed = JSON.parse(jsonEl.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function initHero(root) {
    if (!root || root.dataset.bridgeHeroReady === 'true') return;
    root.dataset.bridgeHeroReady = 'true';

    const optionsRoot = root.querySelector('[data-bridge-options]');
    if (!optionsRoot) return;

    const jsonEl = optionsRoot.querySelector('[data-bridge-variants]');
    if (!jsonEl) return;

    const variants = parseVariants(jsonEl);

    function selectedValues() {
      return Array.from(optionsRoot.querySelectorAll('input[type="radio"]:checked')).map(
        (input) => input.value
      );
    }

    function orderForms() {
      return document.querySelectorAll('[data-bridge-order]');
    }

    function sync() {
      const selected = selectedValues();
      const match = variants.find((variant) => {
        const options = variant.options || [];
        return (
          selected.length === options.length &&
          selected.every((value, index) => options[index] === value)
        );
      });

      orderForms().forEach((form) => {
        const variantInput = form.querySelector('[ref="variantId"], input[name="id"]');
        const button = form.querySelector('[ref="addToCartButton"]');
        if (variantInput && match) variantInput.value = String(match.id);
        if (button) button.disabled = !match;
      });
    }

    optionsRoot.addEventListener('change', sync);
    sync();
  }

  function initAll() {
    document.querySelectorAll(HERO_SELECTOR).forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector && event.target.querySelector(HERO_SELECTOR);
    if (root) initHero(root);
  });
})();
